import { render, staticRenderFns } from "./VxSidebarMenu.vue?vue&type=template&id=c3a2032e&"
import script from "./VxSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./VxSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./VxSidebarMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports